module.exports = __webpack_public_path__ + "a1049e33e4ee873be1570e7287fbed61.glb";